import { render, staticRenderFns } from "./changeDateDia.vue?vue&type=template&id=5b0884da&scoped=true&"
import script from "./changeDateDia.vue?vue&type=script&lang=js&"
export * from "./changeDateDia.vue?vue&type=script&lang=js&"
import style0 from "./changeDateDia.vue?vue&type=style&index=0&id=5b0884da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0884da",
  null
  
)

export default component.exports